/**
 * User: British Carter
 * Date: 3/1/16
 * Time: 6:51 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 *
 */

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var strings = require('dibs-strings-helper');

var FEET = 12;
var DEFAULT_FEET_CUTOFF = 48;
var LOWER_FEET_CUTOFF = 24;

var measurements = {
    inch: {
        toCm: function toCm(x) {
            return x * 2.54;
        },
        toFeet: function toFeet(x, feetCutOff) {

            var ret = void 0;
            var feet = void 0;
            var inches = void 0;
            var realFeet = void 0;

            feetCutOff = feetCutOff || 48;

            if (x < feetCutOff) {
                ret = x + '"';
            } else {
                realFeet = x / FEET;
                ret = realFeet + "'";
                if (realFeet % 1 !== 0) {
                    feet = Math.floor(realFeet);
                    inches = Math.round((realFeet - feet) * FEET);
                    ret = feet + "' " + inches + '"';
                }
            }
            return ret;
        }
    },
    cm: {
        toInch: function toInch(x) {
            return x * 0.3937;
        }
    },
    feet: {
        toInch: function toInch(x) {
            var ret = 0;
            // looking for single quote
            var ftIndex = x.indexOf("'");
            // looking for double quote
            var inchIndex = x.indexOf('"');
            var ft = void 0;
            var inch = void 0;
            if (ftIndex !== -1) {
                ft = parseInt(x.substring(0, ftIndex), 10);
                ret += ft * FEET;
            }

            if (inchIndex !== -1) {
                inch = parseInt(x.substring(ftIndex + 1, inchIndex), 10);
                ret += inch;
            }
            return ret;
        },
        toLongForm: function toLongForm(x) {
            return x.replace("'", " ft. ").replace('"', " in.");
        },
        toShortForm: function toShortForm(x) {
            return x.replace(" ft. ", "'").replace(" in.", '"');
        }
    }
};

/**
 * Converts a value into either a number or a string with the appropriate
 * measurement values
 * @param {number|string} num The value to convert from a number > measurement
 * @param {string} [to] Type of value to convert x to ("cm", "inches")
 *                      Note: for measurement conversions, to field is converted to "toX" format to increase
 *                      readability of measurement object
 *                      i.e. if to arg = "cm" the key for look-up in the measurement object will
 *                      be converted to "toCm"
 * @param {string} [from] Type of value to convert x from
 *                        |"inch" to "cm"
 *                        |"feet", "cm" to "inch", "feet" to "long_form").
 * @returns {String}
 */

function convert(options) {
    var num = undefined;
    var from = undefined;
    var to = undefined;
    var feetCutOff = undefined;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
        num = options.num;
        from = options.from;
        to = options.to;
        feetCutOff = options.feetCutOff;
    } else {
        // original signature
        num = arguments[0];
        from = arguments[1];
        to = arguments[2];
    }

    if (!num && typeof num !== 'number') {
        return num;
    }

    to = to || "number";
    from = from || "currency";

    to = 'to' + strings.capitalize(to);
    if (typeof measurements[from][to] === "function") {
        num = measurements[from][to](num, feetCutOff);
        if (typeof num === "number") {
            num = Math.round(num * 100) / 100;
        }
    }
    return num;
}

module.exports = {
    convert: convert,
    DEFAULT_FEET_CUTOFF: DEFAULT_FEET_CUTOFF,
    LOWER_FEET_CUTOFF: LOWER_FEET_CUTOFF
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-measurement-conversions/dist/index.js
// module id = 483
// module chunks = 4 6 7 8 9 10 12 14 23